import React, { useEffect, useState } from 'react';
import Loading from '../_components/Loading';
import { NoData } from '../_components/NoData';
import { Pagination } from '../_components/Pagination';
import { subscriptionService } from '../_services/subscription.service';
import { TopicBox } from './TopicBox';

export const TopicList = ({ topics, handlePagination, paginationData, isLoading }) => {
  const [subscriptionData, setSubscriptionData] = useState({});

  useEffect(() => {
    if (topics[0]?.course_id) {
      handleSubscriptionData();
    }
  }, [topics]);

  const handleSubscriptionData = () => {
    subscriptionService
      .subscriptionList({ course_id: topics[0]?.course_id, status: 1, isactive: 1 })
      .then(
        (res) => {
          if (res?.data?.rows?.length) {
            setSubscriptionData(res.data.rows);
          }
        },
        (err) => {
          console.log('onSubscribeErrrr-----------', err);
        },
      );
  };

  return (
    <div>
      <div className=''>
        {/* <div className='topichead mb-5'>Topics</div> */}
        <div className='d-flex align-items-center gap-1'>
          <div className='d-flex flex-wrap gap-4 courselist'>
            {topics?.map((topic) => {
              return (
                <TopicBox topic={topic} key={topic._id} subscriptionData={subscriptionData[0]} />
              );
            })}
          </div>
        </div>

        {topics?.length == 0 && !isLoading && <NoData text='No Topics Found' />}
        {isLoading && topics.length == 0 && <Loading />}
        <Pagination pageOnClick={(pageNo) => handlePagination(pageNo)} demoData={paginationData} />
      </div>
    </div>
  );
};
